// @ts-nocheck
import {
    chain,
    ValidateEmail as baseValidateEmail,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ValidateEmail = createChainHandler("ValidateEmail", chain, props => {
    // Starter Removed - validation - moved into AccountSettingsUserInformation
});

replaceInChain(chain, baseValidateEmail, ValidateEmail);
